import { render } from "./SwipeableCards.vue?vue&type=template&id=02d1ab6b"
import script from "./SwipeableCards.vue?vue&type=script&lang=js"
export * from "./SwipeableCards.vue?vue&type=script&lang=js"

import "./SwipeableCards.vue?vue&type=style&index=0&id=02d1ab6b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__